module.exports = __webpack_public_path__ + "graphics/basket-glitch.ckh.8414ed513b55ef7d1cd8714c0fc2fa29.svg";